module.exports = __webpack_public_path__ + "img/crm_section_bg.6dcee38e.png";